////////////////Warehouse.js

import { $AjaxJson } from "@/lf";
import { $Urlpath, $UrlApipath } from "@/config/config";
export const WarehouseRequest = {
    GetWarehouse(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetWarehouse", { ID: ID }, function (d) {
            func(d);
        });
    },
    SelectReviceLogisInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SelectReviceLogisInfo", obj, function (d) {
            func(d);
        });
    },
    SelectReceivingBox(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SelectReceivingBox", obj, function (d) {
            func(d);
        });
    },
    
    ChangeAbnoTime(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ChangeAbnoTime", obj, function (d) {
            func(d);
        });
    },
    
    CheckExpressNo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/CheckExpressNo", obj, function (d) {
            func(d);
        });
    },
    GetInventoryTransfer(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetInventoryTransfer", obj, function (d) {
            func(d);
        });
    },
    newReplaceLocation(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/newReplaceLocation", obj, function (d) {
            func(d);
        });
    },
    
    SeachLogisticsDetailsList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SeachLogisticsDetailsList", obj, function (d) {
            func(d)
        })
    },
    SeachLogs(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SeachLogs", obj, function (d) {
            func(d)
        })
    },
    SearchOrderInfo(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchOrderInfo", obj, function (d) {
            func(d);
        });
    },
    Get_Purchases_IsPay(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/Get_Purchases_IsPay",obj , function (d) {
            func(d);
        });
    },
     // 创建1688订单
     CreateAlOrderinfos(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/CreateAlOrderinfos", obj, function (d) {
            func(d)
        })
        
    },

    GetOrder(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetOrder", obj, function (d) {
            func(d)
        })
        
    },
    GetAladdressList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetAladdressList", obj, function (d) {
            func(d)
        })
        
    },
    SearchHomeInventoryCustomer(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchHomeInventoryCustomer", obj, function (d) {
            func(d);
        });
    },
    SearchHomeInventoryCustomerNew(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchHomeInventoryCustomerNew", obj, function (d) {
            func(d);
        });
    },



    AddWarehouse(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddWarehouse", obj, function (d) {
            func(d);
        });
    },

    GetSinglePiciList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetSinglePiciList", obj, function (d) {
            func(d);
        });
    },
    GetOrderStatusfour(func, obj) {
        $AjaxJson($UrlApipath + "Order/GetOrderStatusfour", obj, function (d) {
            func(d);
        });
    },

    UpdateWarehouse(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateWarehouse", obj, function (d) {
            func(d);
        });
    },
    SearchWarehouse(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWarehouse", obj, function (d) {
            func(d);
        });
    },
    // 通过物流单号查询PU单
    PurLogisticsInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/PurLogisticsInfo", obj, function (d) {
            func(d)
        })
    },
    
    //产品标记异常
    ChangeAsnProStatus(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ChangeAsnProStatus", obj, function (d) {
            func(d)
        })
    },
    //添加异常记录
    AddPurlogs(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddPurlogs", obj, function (d) {
            func(d)
        })
    },
    
    
     //采购管理-强制完成
     ChangePuStatus(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ChangePuStatus", obj, function (d) {
            func(d)
        })
    },
    SelectWareHide(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SelectWareHide", obj, function (d) {
            func(d);
        });
    },
    SearchWarehouseList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWarehouseList", obj, function (d) {
            func(d);
        });
    },
    DeleteWarehouse(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteWarehouse", { ID: ID }, function (
            d
        ) {
            func(d);
        });
    },
    SetWarehouseIsPublic(func, ID, IsPublic) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SetWarehouseIsPublic", { ID: ID, IsPublic: IsPublic },
            function (d) {
                func(d);
            }
        );
    },
    SetWarehouseStatus(func, ID, Status) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SetWarehouseStatus", { ID: ID, Status: Status },
            function (d) {
                func(d);
            }
        );
    },
    SetWareHousesStaus(func, ID, Status,Type) {
                        $AjaxJson(
                            $UrlApipath + "Warehouse/SetWareHousesStaus", { ID: ID, Status: Status,Type:Type },
                            function (d) {
                                func(d);
                            }
                        );
    },
        

    //分区
    GetWareHousesZone(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetWareHousesZone", { ID: ID }, function (
            d
        ) {
            func(d);
        });
    },
    AddWareHousesZone(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddWareHousesZone", obj, function (d) {
            func(d);
        });
    },
    UpdateWareHousesZone(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateWareHousesZone", obj, function (d) {
            func(d);
        });
    },
    SearchWareHousesZone(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWareHousesZone", obj, function (d) {
            func(d);
        });
    },
    SearchWareHousesZoneList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWareHousesZoneList", obj, function (
            d
        ) {
            func(d);
        });
    },

    SetWareHousesZoneStatus(func, ID, Status) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SetWareHousesZoneStatus", { ID: ID, Status: Status },
            function (d) {
                func(d);
            }
        );
    },
    SetWareHousesStaus(func, ID, Status,Type) {
                                $AjaxJson(
                                    $UrlApipath + "Warehouse/SetWareHousesStaus", { ID: ID, Status: Status,Type:Type },
                                    function (d) {
                                        func(d);
                                    }
                                );
    },
                
        

    //货架
    GetWareHousesShelf(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/GetWareHousesShelf", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },
    AddWareHousesShelf(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddWareHousesShelf", obj, function (d) {
            func(d);
        });
    },
    UpdateWareHousesShelf(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateWareHousesShelf", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchWareHousesShelf(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWareHousesShelf", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchWareHousesShelfList(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchWareHousesShelfList",
            obj,
            function (d) {
                func(d);
            }
        );
    },
    DeleteWareHousesShelf(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/DeleteWareHousesShelf", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },
     SetWareHousesStaus(func, ID, Status,Type) {
                        $AjaxJson(
                            $UrlApipath + "Warehouse/SetWareHousesStaus", { ID: ID, Status: Status,Type:Type },
                            function (d) {
                                func(d);
                            }
                        );
            },
        
    SetWareHousesShelfShelfType(func, ID, ShelfType) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SetWareHousesShelfShelfType", { ID: ID, ShelfType: ShelfType },
            function (d) {
                func(d);
            }
        );
    },

    SetWareHousesShelfStatus(func, ID, Status) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SetWareHousesShelfStatus", { ID: ID, Status: Status },
            function (d) {
                func(d);
            }
        );
    },
     SetWareHousesStaus(func, ID, Status,Type) {
                $AjaxJson(
                    $UrlApipath + "Warehouse/SetWareHousesStaus", { ID: ID, Status: Status,Type:Type },
                    function (d) {
                        func(d);
                    }
                );
    },



    //库位信息
    GetWareHousesLocation(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/GetWareHousesLocation", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },

    //库位信息
    GetWareHousesLocationsBySKU(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/GetWareHousesLocationsBySKU", obj,
            function (d) {
                func(d);
            }
        );
    },

    //库位信息
    GetWareHousesZoneEND(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/GetWareHousesZoneEND", obj,
            function (d) {
                func(d);
            }
        );
    },

    
    //仓库信息
    SerachWareHouseS(func, SKU) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SerachWareHouseS", { SKU: SKU },
            function (d) {
                func(d);
            }
        );
    },


    AddWareHousesLocation(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddWareHousesLocation", obj, function (
            d
        ) {
            func(d);
        });
    },
    UpdateWareHousesLocation(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateWareHousesLocation", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchWareHousesLocation(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWareHousesLocation", obj, function (
            d
        ) {
            func(d);
        });
    },
    GerProductInventorys(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GerProductInventorys", obj, function (
            d
        ) {
            func(d);
        });
    },

    //同步海外仓库存
    Get4PXStock(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/Get4PXStock", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchWareHousesLocationList(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchWareHousesLocationList",
            obj,
            function (d) {
                func(d);
            }
        );
    },

    SetLocationsVolumeAndWeightByShelfID(
        func,
        WareHousesShelfID,
        Volume,
        Weight
    ) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SetLocationsVolumeAndWeightByShelfID", { Weight: Weight, Volume: Volume, WareHousesShelfID: WareHousesShelfID },
            function (d) {
                func(d);
            }
        );
    },

    SetWareHousesLocationStatus(func, ID, Status) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchWareHousesLocation", { ID: ID, Status: Status },
            function (d) {
                func(d);
            }
        );
    },

    //拣货路径规划
    GetWareHousesPath(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetWareHousesPath", { ID: ID }, function (
            d
        ) {
            func(d);
        });
    },
    AddWareHousesPath(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddWareHousesPath", obj, function (d) {
            func(d);
        });
    },
    UpdateWareHousesPath(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateWareHousesPath", obj, function (d) {
            func(d);
        });
    },
    SearchWareHousesPath(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWareHousesPath", obj, function (d) {
            func(d);
        });
    },
    SearchWareHousesJoinPath(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWareHousesJoinPath", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchWareHousesPathList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchWareHousesPathList", obj, function (
            d
        ) {
            func(d);
        });
    },
    SetWareHousesPathStatus(func, ID, Status) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchWareHousesPath", { ID: ID, Status: Status },
            function (d) {
                func(d);
            }
        );
    },

    //拣货路径规划详细
    GetWareHousesPathDetail(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/GetWareHousesPathDetail", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },
    AddWareHousesPathDetail(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddWareHousesPathDetail", obj, function (
            d
        ) {
            func(d);
        });
    },
    UpdateWareHousesPathDetail(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/UpdateWareHousesPathDetail",
            obj,
            function (d) {
                func(d);
            }
        );
    },

    UploadWareHousesPathDetail(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/UploadWareHousesPathDetail",
            obj,
            function (d) {
                func(d);
            }
        );
    },

    SearchWareHousesPathDetail(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchWareHousesPathDetail",
            obj,
            function (d) {
                func(d);
            }
        );
    },
    SearchWareHousesPathDetailList(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchWareHousesPathDetailList",
            obj,
            function (d) {
                func(d);
            }
        );
    },
    DeleteWareHousesPathDetail(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/DeleteWareHousesPathDetail", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },
    UpperWareHousesPathDetail(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/UpperWareHousesPathDetail", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },
    LowerWareHousesPathDetail(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/LowerWareHousesPathDetail", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },

    //仓储订单处理费折扣
    GetOpentorFeeDiscount(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/GetOpentorFeeDiscount", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },
    AddOpentorFeeDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddOpentorFeeDiscount", obj, function (
            d
        ) {
            func(d);
        });
    },
    UpdateOpentorFeeDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateOpentorFeeDiscount", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchOpentorFeeDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchOpentorFeeDiscount", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchOpentorFeeDiscountList(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchOpentorFeeDiscountList",
            obj,
            function (d) {
                func(d);
            }
        );
    },
    DeleteOpentorFeeDiscount(func, IDArr) {
        $AjaxJson(
            $UrlApipath + "Warehouse/DeleteOpentorFeeDiscount",
            IDArr,
            function (d) {
                func(d);
            }
        );
    },

    //订单处理费（分段）
    GetOrderOpentorFee(func, ID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/GetOrderOpentorFee", { ID: ID },
            function (d) {
                func(d);
            }
        );
    },
    AddOrderOpentorFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddOrderOpentorFee", obj, function (d) {
            func(d);
        });
    },
    UpdateOrderOpentorFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateOrderOpentorFee", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchOrderOpentorFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchOrderOpentorFee", obj, function (
            d
        ) {
            func(d);
        });
    },
    SearchOrderOpentorFeeList(func, obj) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SearchOrderOpentorFeeList",
            obj,
            function (d) {
                func(d);
            }
        );
    },
    DeleteOrderOpentorFee(func, IDArr) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteOrderOpentorFee", IDArr, function (
            d
        ) {
            func(d);
        });
    },

    //
    GetUpFee(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetUpFee", { ID: ID }, function (d) {
            func(d);
        });
    },
    AddUpFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddUpFee", obj, function (d) {
            func(d);
        });
    },
    UpdateUpFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateUpFee", obj, function (d) {
            func(d);
        });
    },
    SearchUpFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchUpFee", obj, function (d) {
            func(d);
        });
    },
    SearchUpFeeList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchUpFeeList", obj, function (d) {
            func(d);
        });
    },
    DeleteUpFee(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteUpFee", { ID: ID }, function (d) {
            func(d);
        });
    },

    SetUpFeeWareHouseID(func, ID, WareHouseID) {
        $AjaxJson(
            $UrlApipath + "Warehouse/SetUpFeeWareHouseID", { ID: ID, WareHouseID: WareHouseID },
            function (d) {
                func(d);
            }
        );
    },


    GetUpFeesDiscount(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetUpFeesDiscount", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddUpFeesDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddUpFeesDiscount", obj, function (d) {
            func(d)
        })
    },
    UpdateUpFeesDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateUpFeesDiscount", obj, function (d) {
            func(d)
        })
    },
    SearchUpFeesDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchUpFeesDiscount", obj, function (d) {
            func(d)
        })
    },
    SearchUpFeesDiscountList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchUpFeesDiscountList", obj, function (d) {
            func(d)
        })
    },
    DeleteUpFeesDiscount(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteUpFeesDiscount", { ID: ID }, function (d) {
            func(d)
        })
    },



    GetPalletFee(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetPalletFee", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddPalletFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddPalletFee", obj, function (d) {
            func(d)
        })
    },
    UpdatePalletFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdatePalletFee", obj, function (d) {
            func(d)
        })
    },
    SearchPalletFee(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPalletFee", obj, function (d) {
            func(d)
        })
    },
    SearchPalletFeeList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPalletFeeList", obj, function (d) {
            func(d)
        })
    },
    DeletePalletFee(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeletePalletFee", { ID: ID }, function (d) {
            func(d)
        })
    },



    GetPalletFeeDiscount(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetPalletFeeDiscount", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddPalletFeeDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddPalletFeeDiscount", obj, function (d) {
            func(d)
        })
    },
    UpdatePalletFeeDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdatePalletFeeDiscount", obj, function (d) {
            func(d)
        })
    },
    SearchPalletFeeDiscount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPalletFeeDiscount", obj, function (d) {
            func(d)
        })
    },
    SearchPalletFeeDiscountList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPalletFeeDiscountList", obj, function (d) {
            func(d)
        })
    },
    DeletePalletFeeDiscount(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeletePalletFeeDiscount", { ID: ID }, function (d) {
            func(d)
        })
    },

    GetCustomerWhouse(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetCustomerWhouse", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddCustomerWhouse(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddCustomerWhouse", obj, function (d) {
            func(d)
        })
    },
    UpdateCustomerWhouse(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateCustomerWhouse", obj, function (d) {
            func(d)
        })
    },
    SearchCustomerWhouse(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchCustomerWhouse", obj, function (d) {
            func(d)
        })
    },
    SearchCustomerWhouseList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchCustomerWhouseList", obj, function (d) {
            func(d)
        })
    },
    DeleteCustomerWhouse(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteCustomerWhouse", { ID: ID }, function (d) {
            func(d)
        })
    },

    SetCustomerWhouseStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetCustomerWhouseStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },



    GetPackInfo(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetPackInfo", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetPackInfoByPackCode(func, PackCode) {
        $AjaxJson($UrlApipath + "Warehouse/GetPackInfoByPackCode", { PackCode: PackCode }, function (d) {
            func(d)
        })
    },

    AddPackInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddPackInfo", obj, function (d) {
            func(d)
        })
    },
    UpdatePackInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdatePackInfo", obj, function (d) {
            func(d)
        })
    },
    SearchPackInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPackInfo", obj, function (d) {
            func(d)
        })
    },
    SearchPackInfoList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPackInfoList", obj, function (d) {
            func(d)
        })
    },
    SetPackInfoStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetPackInfoStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },



};



export const ProductTypeRequest = {
    //删除购物车列表
    DeleteMallCart(func, ID) {
        $AjaxJson($UrlApipath + "Mall/DeleteMallCart", { ID: ID }, function (d) {
            func(d)
        })
    },
    //查询购物车列表
    MallCartPaging(func, obj) {
        $AjaxJson($UrlApipath + "Mall/MallCartPaging", obj, function (d) {
            func(d)
        })
    },
     //获取采购详情
     GetPurchasesDetailsByCart(func, ID) {
        $AjaxJson($UrlApipath + "Mall/GetPurchasesDetailsByCart",  { ID: ID }, function (d) {
            func(d)
        })
    },
    //添加到我的购物车
    AddMallCart(func, obj) {
        $AjaxJson($UrlApipath + "Mall/AddMallCart", obj, function (d) {
            func(d)
        })
    },
    //商城分类列表
    MallProductsPaging(func, obj) {
        $AjaxJson($UrlApipath + "Mall/MallProductsPaging", obj, function (d) {
            func(d)
        })
    },
     //商城列表 分页
     ShopProductsPaging(func, obj) {
        $AjaxJson($UrlApipath + "Shop/ShopProductsPaging", obj, function (d) {
            func(d)
        })
    },
    // 右下角推送列表
    RightProductData(func, obj) {
        $AjaxJson($UrlApipath + "Shop/RightProductData", obj, function (d) {
            func(d)
        })
    },
    //商城产品管理列表
     ProductsPaging(func, obj) {
        $AjaxJson($UrlApipath + "Shop/ProductsPaging", obj, function (d) {
            func(d)
        })
    },
    //商城产品管理修改详情
    GetShopProducts(func, ID) {
        $AjaxJson($UrlApipath + "Shop/GetShopProducts",  { ID: ID }, function (d) {
            func(d)
        })
    },
    //获取商城详情
    GetMallProducts(func, ID) {
        $AjaxJson($UrlApipath + "Mall/GetMallProducts",  { ID: ID }, function (d) {
            func(d)
        })
    },
    //获取商城详情
    GetShopProductDetails(func, ID) {
        $AjaxJson($UrlApipath + "Shop/GetShopProductDetails",  { ID: ID }, function (d) {
            func(d)
        })
    },
    GetProductType(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetProductType", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetProductTypeByUserID(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetProductTypeByUserID", { ID: ID }, function (d) {
            func(d)
        })
    },

    AddProductType(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddProductType", obj, function (d) {
            func(d)
        })
    },
    UpdateProductType(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateProductType", obj, function (d) {
            func(d)
        })
    },
    SearchProductType(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchProductType", obj, function (d) {
            func(d)
        })
    },
    SearchProductTypeList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchProductTypeList", obj, function (d) {
            func(d)
        })
    },

    SetProductTypeStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetProductTypeStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },

}






export const ProductRequest = {

    
    ///通过链接查询SKU
    SeachSKULIST(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SeachSKULIST", obj, function (d) {
            func(d)
        })
    },
    ///修改SKU名称
    UpdateSKUName(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateSKUName", obj, function (d) {
            func(d)
        })
    },
    ///提交映射
    UpdateSKUsepid(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateSKUsepid", obj, function (d) {
            func(d)
        })
    },
    ///匹配1688产品
    getAlPorudctInfos(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/getAlPorudctInfos", obj, function (d) {
            func(d)
        })
    },
    /// 铺货
    SyncProductListPushed(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SyncProductListPushed", obj, function (d) {
            func(d)
        })
    },
    

    //批量确认映射
    ConfirmationMapping(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ConfirmationMapping", obj, function (d) {
            func(d)
        })
    },
    //采购价换算对应销售价
    CalculateSalePrice(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/CalculateSalePrice", obj, function (d) {
            func(d)
        })
    },
    
     //产品管理批量修改
     ModifyProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ModifyProduct", obj, function (d) {
            func(d)
        })
    },
     //产品管理批量设置禁用 批量删除
     DeleteProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteProduct", obj, function (d) {
            func(d)
        })
    },


     //查询运费
     FreightInquiriesByChannelCode(func, obj) {
        $AjaxJson($UrlApipath + "Order/FreightInquiriesByChannelCode", obj, function (d) {
            func(d)
        })
    },
     //查询1688匹配列表
     GetProductInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetProductInfo", obj, function (d) {
            func(d)
        })
    },
  

    GetProduct(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetProduct", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetProductByUserID(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetProductByUserID", { ID: ID }, function (d) {
            func(d)
        })
    },

    AddProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddProduct", obj, function (d) {
            func(d)
        })
    },
    //创建收货框
    AddReceivingBox(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddReceivingBox", obj, function (d) {
            func(d)
        })
    },
      //删除收货框
      DelReceivingBox(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/DelReceivingBox", obj, function (d) {
            func(d)
        })
    },
      //修改收货框
      UpdateReceivingBox(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateReceivingBox", obj, function (d) {
            func(d)
        })
    },
    //添加商城产品
    AddMallProduct(func, obj) {
        $AjaxJson($UrlApipath + "/Mall/AddMallProduct", obj, function (d) {
            func(d)
        })
    },
     //添加商城产品
     AddShopProduct(func, obj) {
        $AjaxJson($UrlApipath + "/Shop/AddShopProduct", obj, function (d) {
            func(d)
        })
    },

    AddProducts(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddProducts", obj, function (d) {
            func(d)
        })
    },
    ListUpdateProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ListUpdateProduct", obj, function (d) {
            func(d)
        })
    },
    ExportUpdateProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ExportUpdateProduct", obj, function (d) {
            func(d)
        })
    },
    // 批量申请报价
    ListAddProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ListAddProduct", obj, function (d) {
            func(d)
        })
    },
    UpdateProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateProduct", obj, function (d) {
            func(d)
        })
    },
    //修改商城产品
    UpdateMallProduct(func, obj) {
        $AjaxJson($UrlApipath + "Mall/UpdateMallProduct", obj, function (d) {
            func(d)
        })
    },
    //修改商城产品
    ModifyShopProduct(func, obj) {
        $AjaxJson($UrlApipath + "Shop/ModifyShopProduct", obj, function (d) {
            func(d)
        })
    },
    SearchProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchProduct", obj, function (d) {
            func(d)
        })
    },
    //查看缺货
    SearchProductStockout(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchProductStockout", obj, function (d) {
            func(d)
        })
    },
    SearchProductList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchProductList", obj, function (d) {
            func(d)
        })
    },

    SetProductStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetProductStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },
    PegOutOfStockStatus(func, id, status) {
        $AjaxJson($UrlApipath + "Warehouse/PegOutOfStockStatus", { id: id, status: status }, function (d) {
            func(d)
        })
    },
    //禁止、启用商城产品
    DisableMallProduct(func, ID, Status) {
        $AjaxJson($UrlApipath + "Mall/DisableMallProduct", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },
    CopyProduct2Customer(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/CopyProduct2Customer", obj, function (d) {
            func(d)
        })
    },
    //商城产品管理-复制产品
    CopyProduct(func, obj) {
        $AjaxJson($UrlApipath + "Shop/CopyProduct", obj, function (d) {
            func(d)
        })
    },


}


export const SupplierRequest = {

    GetSupplier(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetSupplier", { ID: ID }, function (d) {
            func(d)
        })
    },

    GetSupplierByUserID(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetSupplierByUserID", { ID: ID }, function (d) {
            func(d)
        })
    },



    AddSupplier(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddSupplier", obj, function (d) {
            func(d)
        })
    },
    UpdateSupplier(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateSupplier", obj, function (d) {
            func(d)
        })
    },
    SearchSupplier(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchSupplier", obj, function (d) {
            func(d)
        })
    },
    // 采购管理-新增采购单-获取采购人列表
    // SearchSupplier(func, obj) {
    //     $AjaxJson($UrlApipath + "Warehouse/SearchSupplier", obj, function (d) {
    //         func(d)
    //     })
    // },
    SearchSupplierList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchSupplierList", obj, function (d) {
            func(d)
        })
    },

    SetSupplierStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetSupplierStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },
}



export const SkuMappingRequest = {

    GetSkuMapping(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetSkuMapping", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetSkuMappingByUserID(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetSkuMappingByUserID", { ID: ID }, function (d) {
            func(d)
        })
    },


    AddSkuMapping(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddSkuMapping", obj, function (d) {
            func(d)
        })
    },
    UpdateSkuMapping(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateSkuMapping", obj, function (d) {
            func(d)
        })
    },
    UpdateSkuMappingT2(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateSkuMappingT2", obj, function (d) {
            func(d)
        })
    },
    SearchSkuMapping(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchSkuMapping", obj, function (d) {
            func(d)
        })
    },
    SearchSkuMappingList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchSkuMappingList", obj, function (d) {
            func(d)
        })
    },

    SetSkuMappingStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetSkuMappingStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },

    AddSkuMappingList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddSkuMappings", obj, function (d) {
            func(d)
        })
    },
    DeleteSkuMapping(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteSkuMapping", { ID: ID }, function (d) {
            func(d)
        })
    },

    DeleteSkuMappings(func, IDs) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteSkuMappings", { IDs: IDs }, function (d) {
            func(d)
        })
    },



}



export const ASN_PurchasesRequest = {
   
 
    GetASN_Purchases(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetASN_Purchases", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetASN_PurchasesNew(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetASN_PurchasesNew", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetLogisticsDetailsList(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetLogisticsDetailsList", { id: ID }, function (d) {
            func(d)
        })
    },
    GetTokenUrl(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetTokenUrl", obj, function (d) {
            func(d)
        })
    },
    GetPurchasesDetails(func, ID) {
        $AjaxJson($UrlApipath + "Mall/GetPurchasesDetails", { ID: ID }, function (d) {
            func(d)
        })
    },

    GetASN_PurchasesByUserID(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetASN_PurchasesByUserID", { ID: ID }, function (d) {
            func(d)
        })
    },

    GetASN_PurchasesByNo(func, No) {
        $AjaxJson($UrlApipath + "Warehouse/GetASN_PurchasesByNo", { No: No }, function (d) {
            func(d)
        })
    },
    GetASN_PurchasesByNos(func, No) {
        $AjaxJson($UrlApipath + "Warehouse/GetASN_PurchasesByNos", { No: No }, function (d) {
            func(d)
        })
    },




    AddASN_Purchases(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddASN_Purchases", obj, function (d) {
            func(d)
        })
    },
    // 新增采购单
    AddASNPurchases(func, obj) {
        $AjaxJson($UrlApipath + "Mall/AddASNPurchases", obj, function (d) {
            func(d)
        })
    },
    UpdateASN_Purchases(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateASN_Purchases", obj, function (d) {
            func(d)
        })
    },
    ModifyASNPurchases(func, obj) {
        $AjaxJson($UrlApipath + "Mall/ModifyASNPurchases", obj, function (d) {
            func(d)
        })
    },
    UpdateASN_PurchasesOther(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateASN_PurchasesOther", obj, function (d) {
            func(d)
        })
    },
    SearchASN_Purchases(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchASN_Purchases", obj, function (d) {
            func(d)
        })
    },
    UpdatePurAccount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdatePurAccount", obj, function (d) {
            func(d)
        })
    },
    AddPurAccount(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddPurAccount", obj, function (d) {
            func(d)
        })
    },
    SerachPurAccountNo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SerachPurAccountNo", obj, function (d) {
            func(d)
        })
    },

      // 查看物流地址
      GetPurLogisticsInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetPurLogisticsInfo", obj, function (d) {
            func(d)
        })
    },
     // 通过快递单号添加物流信息
     ADDLogisticsInfos(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ADDLogisticsInfos", obj, function (d) {
            func(d)
        })
    },
     // 通过1688订单号添加物流信息
     GetLogisticsTraceInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetLogisticsTraceInfo", obj, function (d) {
            func(d)
        })
    },
   
    // 新增采购单-查看缺货
    SearchProductStockout(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchProductStockout", obj, function (d) {
            func(d)
        })
    },
    MallPurchasesPaging(func, obj) {
        $AjaxJson($UrlApipath + "Mall/MallPurchasesPaging", obj, function (d) {
            func(d)
        })
    },
    SearchASN_PurchasesList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchASN_PurchasesList", obj, function (d) {
            func(d)
        })
    },

    SetASN_PurchasesStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetASN_PurchasesStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },
    UpdateAsn_PurchaseStatus(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateAsn_PurchaseStatus", obj, function (d) {
            func(d)
        })
    },
    UpdateAcountUsers(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateAcountUsers", obj, function (d) {
            func(d)
        })
    },
    GetReceiveAddress(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetReceiveAddress", obj, function (d) {
            func(d)
        })
    },
    PurLogisticsInfo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/PurLogisticsInfo", obj, function (d) {
            func(d)
        })
    },
    SetASNPurchasesStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Mall/SetASNPurchasesStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },

    SetASN_PurchasesIsPay(func, ID, IsPay) {
        $AjaxJson($UrlApipath + "Warehouse/SetASN_PurchasesIsPay", { ID: ID, IsPay: IsPay }, function (d) {
            func(d)
        })
    },
    SetASNPurchasesIsPay(func, ID, IsPay) {
        $AjaxJson($UrlApipath + "Mall/SetASNPurchasesIsPay", { ID: ID, IsPay: IsPay }, function (d) {
            func(d)
        })
    },
}




export const InventoryCustomerRequest = {

    GetInventoryCustomer(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetInventoryCustomer", { ID: ID }, function (d) {
            func(d)
        })
    },

    SearchInventoryCustomer(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryCustomer", obj, function (d) {
            func(d)
        })
    },
    //查看备用库存
    GetListTransfer(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetListTransfer", obj, function (d) {
            func(d)
        })
    },
    SearchProductInventoryCustomer(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchProductInventoryCustomer", obj, function (d) {
            func(d)
        })
    },
    // 查看我的库存缺货列表
    SearchInventoryCustomerStockout(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryCustomerStockout", obj, function (d) {
            func(d)
        })
    },
        // 查看我的库存在途数量列表
        SeachProducIntransit(func, obj) {
            $AjaxJson($UrlApipath + "Warehouse/SeachProducIntransit", obj, function (d) {
                func(d)
            })
        },
    ExportInventoryCustomer(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ExportInventoryCustomer", obj, function (d) {
            func(d)
        })
    },



    SearchInventoryCustomerList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryCustomerList", obj, function (d) {
            func(d)
        })
    },

}

export const InventoryTotalRequest = {

    GetInventoryTotal(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetInventoryTotal", { ID: ID }, function (d) {
            func(d)
        })
    },
    SearchInventoryTotal(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryTotal", obj, function (d) {
            func(d)
        })
    },
    SearchInventoryTotalList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryTotalList", obj, function (d) {
            func(d)
        })
    },

}



export const InventoryRequest = {

    GetInventory(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetInventory", { ID: ID }, function (d) {
            func(d)
        })
    },
    //库位盘点
    SearchInventory(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventory", obj, function (d) {
            func(d)
        })
    },
    //SKU盘点查询
    SearchSkuInventory(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchSkuInventory", obj, function (d) {
            func(d)
        })
    },
    SearchInventoryList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryList", obj, function (d) {
            func(d)
        })
    },

}






export const ASN_ReceivesRequest = {

    GetASN_Receives(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetASN_Receives", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetASN_ReceiveDetailList(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetASN_ReceiveDetailList", ID, function (d) {
            func(d)
        })
    },

    ASN_ReceviesRemakrs(func,obj){
        $AjaxJson($UrlApipath+"Warehouse/AddASN_ReceivesRemarks",obj,function(d){
            func(d)
        })

    },

    AddASN_Receives(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddASN_Receives", obj, function (d) {
            func(d)
        })
    },
    UpdateASN_Receives(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateASN_Receives", obj, function (d) {
            func(d)
        })
    },
    SearchASN_Receives(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchASN_Receives", obj, function (d) {
            func(d)
        })
    },
    SearchASN_ReceivesList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchASN_ReceivesList", obj, function (d) {
            func(d)
        })
    },
    ASN_ReceivesOnTheShelf(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ASN_ReceivesOnTheShelf", obj, function (d) {
            func(d)
        })
    },

}


export const InventoryInAndOutRequest = {

    GetInventoryInAndOut(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetInventoryInAndOut", { ID: ID }, function (d) {
            func(d)
        })
    },

    SearchInventoryInAndOut(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryInAndOut", obj, function (d) {
            func(d)
        })
    },
    SearchInventoryInAndOutList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryInAndOutList", obj, function (d) {
            func(d)
        })
    },

    // 库存调整-新增
    AddInventoryInAndOut(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddInventoryInAndOut", obj, function (d) {
            func(d)
        })
    },
    AddInventoryInAndOutList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddInventoryInAndOutList", obj, function (d) {
            func(d)
        })
    },
    // 库存调整-是否仓库备货
    TransferInventory(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/TransferInventory", obj, function (d) {
            func(d)
        })
    },
}



export const PickUpBatchRequest = {

    GetPickUpBatch(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetPickUpBatch", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetPickUpBatchFendan(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetPickUpBatchFendan", {
            ID: ID
        }, function (d) {
            func(d)
        })
    },
    AddPickUpBatch(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddPickUpBatch", obj, function (d) {
            func(d)
        })
    },
    UpdatePrintStatus(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdatePrintStatus", obj, function (d) {
            func(d)
        })
    },
    ExportPickUpBatchList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ExportPickUpBatchList", obj, function (d) {
            func(d)
        })
    },
    SearchPickUpBatch(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPickUpBatch", obj, function (d) {
            func(d)
        })
    },
    UpdataPatchRemarks(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdataPatchRemarks", obj, function (d) {
            func(d)
        })
    },
    SearchPickUpBatchList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPickUpBatchList", obj, function (d) {
            func(d)
        })
    },
    DeletePickUpBatch(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeletePickUpBatch", { ID: ID }, function (d) {
            func(d)
        })
    },

    SetPickUpBatchIsPrint(func, ID, IsPrint) {
        $AjaxJson($UrlApipath + "Warehouse/SetPickUpBatchIsPrint", { ID: ID, IsPrint: IsPrint }, function (d) {
            func(d)
        })
    },


    CompletePickUpBatch(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/CompletePickUpBatch", { ID: ID }, function (d) {
            func(d)
        })
    },

    OrderLabelGet(func, ID) {
        $AjaxJson($UrlApipath + "Order/OrderLabelGet", { ID: ID }, function (d) {
            func(d)
        })
    },

    AddPickUpBatchPrintTimes(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/AddPickUpBatchPrintTimes", { ID: ID }, function (d) {
            func(d)
        })
    },


    AddOrderDetailCheckQty(func, OrderDetailID) {
        $AjaxJson($UrlApipath + "Warehouse/AddOrderDetailCheckQty", { OrderDetailID: OrderDetailID }, function (d) {
            func(d)
        })

    },


    DeletePickUpBatchOrderDetailCheckQty(func, PickUpBatchID) {
        $AjaxJson($UrlApipath + "Warehouse/DeletePickUpBatchOrderDetailCheckQty", { PickUpBatchID: PickUpBatchID }, function (d) {
            func(d)
        })

    },



    SingleOrderReinsurance(func, PickUpBatchID, ProdutCode) {
        $AjaxJson($UrlApipath + "Warehouse/SingleOrderReinsurance", { PickUpBatchID: PickUpBatchID, ProdutCode: ProdutCode }, function (d) {
            func(d)
        })
    },



    OrderForProductCheck(func, OrderNo) {
        $AjaxJson($UrlApipath + "Warehouse/OrderForProductCheck", { OrderNo: OrderNo }, function (d) {
            func(d)
        })
    },

    ChangeOrderChecks (func, OrderNo,IsOrderChecks) {
        $AjaxJson($UrlApipath + "Order/ChangeOrderChecks ", { OrderNo: OrderNo ,IsOrderChecks:IsOrderChecks}, function (d) {
            func(d)
        })
    },

    RecallOrder (func, OrderNo) {
        $AjaxJson($UrlApipath + "Order/RecallOrder ", { OrderNo: OrderNo }, function (d) {
            func(d)
        })
    },

    SearchPickUpManage(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchPickUpManage", obj, function (d) {
            func(d)
        })
    },


}





export const DeliverBacthRequest = {

    GetDeliverBacth(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetDeliverBacth", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetDeliverBacthByIncludePaths(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/GetDeliverBacthByIncludePaths", obj, function (d) {
            func(d)
        })
    },


    AddDeliverBacthDetailByOrderNoAll(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddDeliverBacthDetailByOrderNoAll", obj, function (d) {
            func(d)
        })
    },

    ModifyDeliverBacthRemark(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/ModifyDeliverBacthRemark", obj, function (d) {
            func(d)
        })
    },

   
    AddDeliverBacth(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddDeliverBacth", obj, function (d) {
            func(d)
        })
    },
    UpdateDeliverBacth(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateDeliverBacth", obj, function (d) {
            func(d)
        })
    },
    SearchDeliverBacth(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchDeliverBacth", obj, function (d) {
            func(d)
        })
    },
    SearchDeliverBacthList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchDeliverBacthList", obj, function (d) {
            func(d)
        })
    },

}


export const DeliverBacthDetailRequest = {

    GetDeliverBacthDetail(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetDeliverBacthDetail", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddDeliverBacthDetail(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddDeliverBacthDetail", obj, function (d) {
            func(d)
        })
    },
    AddDeliverBacthDetailByOrderNo(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddDeliverBacthDetailByOrderNo", obj, function (d) {
            func(d)
        })
    },


    UpdateDeliverBacthDetail(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateDeliverBacthDetail", obj, function (d) {
            func(d)
        })
    },
    SearchDeliverBacthDetail(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchDeliverBacthDetail", obj, function (d) {
            func(d)
        })
    },
    SearchDeliverBacthDetailList(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SearchDeliverBacthDetailList", obj, function (d) {
            func(d)
        })
    },
    DeleteDeliverBacthDetail(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/DeleteDeliverBacthDetail", { ID: ID }, function (d) {
            func(d)
        })
    },

    SetDeliverBacthTotalWeight(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/SetDeliverBacthTotalWeight", obj, function (d) {
            func(d)
        })
    },




}



export const CancelReceiptRequest = {
    CancelReceipt(func, OrderNoOrTrackingNo) {
        $AjaxJson($UrlApipath + "Warehouse/CancelReceipt", { OrderNoOrTrackingNo: OrderNoOrTrackingNo }, function (d) {
            func(d)
        })
    },
    //撤销拣货
    ClearPickingBatches(func, OrderNoOrTrackingNo) {
        $AjaxJson($UrlApipath + "Warehouse/ClearPickingBatches", { Orders: OrderNoOrTrackingNo }, function (d) {
            func(d)
        })
    },
}



//////////////// Warehouse.js End ////////////////


export const ShopProductRequest = {

    GetShopProduct(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetShopProduct", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddShopProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddShopProduct", obj, function (d) {
            func(d)
        })
    },
    UpdateShopProduct(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateShopProduct", obj, function (d) {
            func(d)
        })
    },
    SearchShopProduct(func, obj, Option) {
        $AjaxJson($UrlApipath + "Warehouse/SearchShopProduct", obj, function (d) {
            func(d)
        }, false, Option && Option.isNotzbcShow ? Option.isNotzbcShow : true, Option)
    },
    SearchShopProductList(func, obj, Option) {
        $AjaxJson($UrlApipath + "Warehouse/SearchShopProductList", obj, function (d) {
            func(d)
        }, false, Option && Option.isNotzbcShow ? Option.isNotzbcShow : true, Option)
    },

    SetShopProductIsMapping(func, ID, IsMapping) {
        $AjaxJson($UrlApipath + "Warehouse/SetShopProductIsMapping", { ID: ID, IsMapping: IsMapping }, function (d) {
            func(d)
        })
    },
    SetShopProductStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Warehouse/SetShopProductStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },
}

////////////////ShopProduct.js End ///////////////////



export const InventoryCheckRequest = {

    GetInventoryCheck(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/GetInventoryCheck", { ID: ID }, function (d) {
            func(d)
        })
    },
    //盘点作废
    CancellationInventoryCheck(func, ID) {
        $AjaxJson($UrlApipath + "Warehouse/CancellationInventoryCheck", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddInventoryCheck(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/AddInventoryCheck", obj, function (d) {
            func(d)
        })
    },
    UpdateInventoryCheck(func, obj) {
        $AjaxJson($UrlApipath + "Warehouse/UpdateInventoryCheck", obj, function (d) {
            func(d)
        })
    },
    SearchInventoryCheck(func, obj, Option) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryCheck", obj, function (d) {
            func(d)
        }, false, Option && Option.isNotzbcShow ? Option.isNotzbcShow : true, Option)
    },
    SearchInventoryCheckList(func, obj, Option) {
        $AjaxJson($UrlApipath + "Warehouse/SearchInventoryCheckList", obj, function (d) {
            func(d)
        }, false, Option && Option.isNotzbcShow ? Option.isNotzbcShow : true, Option)
    },
  
    SetInventoryCheckCheckStatus(func, ID, CheckStatus,AuditRemark) {
        $AjaxJson($UrlApipath + "Warehouse/SetInventoryCheckCheckStatus", { ID: ID, CheckStatus: CheckStatus,AuditRemark:AuditRemark }, function (d) {
            func(d)
        })
    },

}


////////////////InventoryCheck.js End ///////////////////














// WEBPACK FOOTER //
// ./src/request/Warehouse.js